import React from 'react';
import { Typography, Autocomplete, TextField, Stack } from '@mui/material';
import { useDoc } from '../hooks';

export const Input = ({
    inputType,
    placeholder,
    value,
    label,
    step,
    onTextChange,
    freeSolo,
    noOptions,
}) => {
    const { data:advantages } = useDoc(`configurations/advantages`);

    if (!advantages) return <Typography h1>Loading</Typography>;
    {
        switch (inputType) {
            case (inputType = 'advantages'):
                return (
                    <Stack spacing={3} sx={{ width: '100%' }}>
                        <Autocomplete
                            onChange={(_, value) => onTextChange(value)}
                            multiple
                            id="tags-outlined"
                            options={noOptions ? [] : advantages.ADVANTAGES}
                            defaultValue={value}
                            freeSolo={freeSolo}
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={placeholder}
                                />
                            )}
                        />
                    </Stack>
                );
            case (inputType = 'size'):
                return (
                    <TextField
                        onChange={(e) => onTextChange(e.target.value)}
                        label={label}
                        type="number"
                        defaultValue={value}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            step: step,
                        }}
                        style={{ width: '8vw' }}
                    />
                );
            case (inputType = 'labelOutlined'):
                return (
                    <TextField
                        onChange={(e) => onTextChange(e.target.value)}
                        variant="outlined"
                        label={label}
                    />
                );
            case (inputType = 'edit'):
                return (
                    <TextField
                        onChange={(e) => onTextChange(e.target.value)}
                        variant="outlined"
                        defaultValue={value}
                    />
                );
            case (inputType = 'time'):
                return (
                    <TextField
                        onChange={(e) => onTextChange(e.target.value)}
                        id="time"
                        label={label}
                        type="time"
                        defaultValue={value}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            step: 300,
                        }}
                        style={{ width: '8vw' }}
                    />
                );
            case (inputType = 'default'):
                return (
                    <TextField
                        onChange={(e) => onTextChange(e.target.value)}
                        variant="outlined"
                        placeholder={placeholder}
                    />
                );
        }
    }
};

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

const top100Films = [
    { title: 'The Shawshank Redemption', year: 1994 },
    { title: 'The Godfather', year: 1972 },
    { title: 'The Godfather: Part II', year: 1974 },
    { title: 'The Dark Knight', year: 2008 },
    { title: '12 Angry Men', year: 1957 },
    { title: "Schindler's List", year: 1993 },
    { title: 'Pulp Fiction', year: 1994 },
    {
        title: 'The Lord of the Rings: The Return of the King',
        year: 2003,
    },
];
